import { Link } from "react-router-dom";
import { MapPin, Mail } from "lucide-react";
import { useLang } from "@/lib/lang";

export default function Footer() {
  const { t, lang } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-zinc-200 bg-white" data-testid="footer">
      <div className="max-w-6xl mx-auto px-6 md:px-12 py-10 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 text-[#8b6f3d] mb-3">
            <MapPin size={18} />
            <span className="font-mono-data text-xs uppercase tracking-widest">Atlas · 0.3</span>
          </div>
          <div className="font-serif-mystery text-2xl text-zinc-900 mb-2">
            {lang === "fr" ? "La seule carte dont vous aurez besoin" : "The Only Map You Will Ever Need"}
          </div>
          <p className="text-sm text-zinc-500 max-w-md">
            {lang === "fr"
              ? "Treasure Hunt • Legends • UFOs • And More — Une exploration mondiale des mystères de notre planète."
              : "Treasure Hunt • Legends • UFOs • And More — A worldwide exploration of our planet's mysteries."}
          </p>
        </div>

        <div>
          <div className="font-mono-data text-[10px] uppercase tracking-widest text-zinc-500 mb-3">
            {lang === "fr" ? "Navigation" : "Navigation"}
          </div>
          <ul className="space-y-2 text-sm text-zinc-700">
            <li><Link to="/" className="hover:text-[#8b6f3d]" data-testid="footer-home">{lang === "fr" ? "Accueil" : "Home"}</Link></li>
            <li><Link to="/map" className="hover:text-[#8b6f3d]" data-testid="footer-map">{lang === "fr" ? "Carte" : "Map"}</Link></li>
            <li><Link to="/explorer" className="hover:text-[#8b6f3d]" data-testid="footer-explorer">{lang === "fr" ? "Explorer" : "Explore"}</Link></li>
            <li><Link to="/store" className="hover:text-[#8b6f3d]" data-testid="footer-store">{lang === "fr" ? "Boutique" : "Store"}</Link></li>
            <li><Link to="/profile" className="hover:text-[#8b6f3d]" data-testid="footer-profile">{lang === "fr" ? "Mon profil" : "My profile"}</Link></li>
            <li><Link to="/about" className="hover:text-[#8b6f3d]" data-testid="footer-about">{lang === "fr" ? "À propos" : "About"}</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-mono-data text-[10px] uppercase tracking-widest text-zinc-500 mb-3">
            {lang === "fr" ? "Légal" : "Legal"}
          </div>
          <ul className="space-y-2 text-sm text-zinc-700">
            <li><Link to="/privacy" className="hover:text-[#8b6f3d]" data-testid="footer-privacy">{lang === "fr" ? "Politique de confidentialité" : "Privacy Policy"}</Link></li>
            <li><Link to="/terms" className="hover:text-[#8b6f3d]" data-testid="footer-terms">{lang === "fr" ? "Conditions d'utilisation" : "Terms of Use"}</Link></li>
            <li className="pt-2 flex items-center gap-2 text-zinc-500">
              <Mail size={12} />
              <a href="mailto:BLEUREEFOBERMAYR@GMAIL.COM" className="hover:text-[#8b6f3d] text-xs break-all">BLEUREEFOBERMAYR@GMAIL.COM</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-100 py-4 text-center text-xs font-mono-data text-zinc-400" data-testid="footer-copyright">
        © {year} — {lang === "fr" ? "La seule carte dont vous aurez besoin. Tous droits réservés." : "The Only Map You Will Ever Need. All rights reserved."}
      </div>
    </footer>
  );
}
